import { Controller } from '@hotwired/stimulus';
import { csrfToken, localTime } from './helpers/general';

export default class extends Controller {
  static targets = ['enableButton', 'disableButton', 'buttonContainer'];
  static values = {
    isActive: Boolean,
    undistractorOptionId: String,
    updateUndistractorUrl: String,
    updateActivationStateUrl: String,
    key: String,
    schedule: String,
    suggestionId: String,
  };

  #abortController = null;

  updateSuggestionState(active) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.isActiveValue = active;
    this.#applySlideUp(active);
    this.#dispatchExtensionUpdate(active);

    this.#remoteActiveStateSync(active, this.undistractorOptionIdValue, signal)
      .then((response) => {
        if (signal.aborted) return;
        if (!response.ok) {
          this.isActiveValue = !active;
          this.#applySlideUp(!active);
          this.#dispatchExtensionUpdate(!active);
          this.showErrorTooltip(this.#targetButton(active));
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        throw error;
      });
  }

  triggerEnableButton() {
    this.updateSuggestionState(true);
  }

  triggerDisableButton() {
    this.updateSuggestionState(false);
  }

  showErrorTooltip(target) {
    const tooltip = new bootstrap.Tooltip(target, {
      trigger: 'manual',
      placement: 'bottom',
    });

    tooltip.show();

    setTimeout(() => tooltip.dispose(), 3000);
  }

  #applySlideUp(active) {
    this.buttonContainerTarget.classList.toggle('action-button-slide-up', active);
  }

  #targetButton(active) {
    return active == true ? this.enableButtonTarget : this.disableButtonTarget;
  }

  async #remoteActiveStateSync(isActive, undistractorOptionId, signal) {
    const response = await fetch(this.updateActivationStateUrlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        undistractor_settings: {
          active: isActive,
          undistractor_option_id: undistractorOptionId,
          local_time: localTime(),
          source: 'suggestion',
          suggestion_id: this.suggestionIdValue || undefined,
        },
      }),
      signal,
    });

    return response;
  }

  #dispatchExtensionUpdate(active) {
    const event = new CustomEvent('updateExtensionValues', {
      bubbles: true,
      detail: [
        {
          key: this.keyValue,
          schedule: this.scheduleValue || null,
          active: active,
        },
      ],
    });
    document.dispatchEvent(event);
  }
}
